<div #container class="canvas-wrapper"   >  
  <canvas class="d-flex" #rendererCanvas id="{{panel.longId}}"></canvas>  
</div>